import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { scrollToSection } from '@/app/shared/helpers';

@Component({
  selector: '[app-footer]',
  standalone: true,
  imports: [RouterModule],
  template: `
    <div class="border-t mt-24">
      <div class="landing-container py-16 grid gap-12 md:grid-cols-4">
        <div class="md:col-span-2 flex flex-col gap-4">
          <a routerLink="/landing" class="flex items-center gap-2 w-fit">
            <span
              class="w-9 h-9 rounded-full bg-primary-active flex items-center justify-center text-surface-0"
            >
              <i class="pi pi-chart-line"></i>
            </span>
            <span class="text-lg font-semibold">PlanTrack</span>
          </a>
          <p class="text-surface-500 max-w-sm">
            Plataforma de gestión de órdenes, plantillas y producción para
            equipos que necesitan control y trazabilidad de punta a punta.
          </p>
          <div class="flex items-center gap-3 mt-2">
            <a
              href="#"
              aria-label="LinkedIn"
              class="w-10 h-10 rounded-full flex items-center justify-center shadow-stroke hover:bg-surface-100 dark:hover:bg-surface-900"
            >
              <i class="pi pi-linkedin"></i>
            </a>
            <a
              href="mailto:contacto@var-tech.org"
              aria-label="Email"
              class="w-10 h-10 rounded-full flex items-center justify-center shadow-stroke hover:bg-surface-100 dark:hover:bg-surface-900"
            >
              <i class="pi pi-envelope"></i>
            </a>
          </div>
        </div>

        <div class="flex flex-col gap-3">
          <span class="font-medium">Producto</span>
          <a
            href="#caracteristicas"
            (click)="scrollTo('caracteristicas', $event)"
            class="text-surface-500 hover:text-surface-950 dark:hover:text-surface-0"
            >Características</a
          >
          <a
            href="#como-funciona"
            (click)="scrollTo('como-funciona', $event)"
            class="text-surface-500 hover:text-surface-950 dark:hover:text-surface-0"
            >Cómo funciona</a
          >
          <a
            href="#planes"
            (click)="scrollTo('planes', $event)"
            class="text-surface-500 hover:text-surface-950 dark:hover:text-surface-0"
            >Planes</a
          >
          <a
            routerLink="/auth/login"
            class="text-surface-500 hover:text-surface-950 dark:hover:text-surface-0"
            >Iniciar sesión</a
          >
        </div>

        <div class="flex flex-col gap-3">
          <span class="font-medium">Contacto</span>
          <a
            href="mailto:contacto@var-tech.org"
            class="text-surface-500 hover:text-surface-950 dark:hover:text-surface-0"
          >
            contacto&#64;var-tech.org
          </a>
          <span class="text-surface-500">Lun. a Vie. 9:00 - 18:00</span>
          <a
            href="#contacto"
            (click)="scrollTo('contacto', $event)"
            class="text-surface-500 hover:text-surface-950 dark:hover:text-surface-0"
            >Formulario de contacto</a
          >
        </div>
      </div>

      <div class="border-t">
        <div
          class="landing-container py-6 flex flex-col sm:flex-row items-center justify-between gap-2"
        >
          <p class="text-surface-500 text-sm">
            &copy; {{ currentYear }} PlanTrack. Todos los derechos reservados.
          </p>
          <div class="flex items-center gap-4">
            <a
              routerLink="/landing/privacy-policy"
              class="text-surface-500 hover:text-surface-950 dark:hover:text-surface-0 text-sm"
            >
              Política de Privacidad
            </a>
            <a
              routerLink="/landing/terms-of-service"
              class="text-surface-500 hover:text-surface-950 dark:hover:text-surface-0 text-sm"
            >
              Términos y Condiciones
            </a>
            <p class="text-surface-500 text-sm">Un producto de Var-Tech</p>
          </div>
        </div>
      </div>
    </div>
  `,
  host: {
    class: 'block',
  },
})
export class Footer {
  currentYear = new Date().getFullYear();

  scrollTo(id: string, event: Event): void {
    scrollToSection(id, event);
  }
}
